import styled from 'styled-components';

const ItemStyles = styled.div`
    background: white;
    border-bottom: 1px solid ${props => props.theme.offWhite};
    padding: 15px 0;
    /* box-shadow: ${props => props.theme.bs}; */
    position: relative;
    display: grid;
    grid-template-columns: 160px 1fr;
    grid-gap: 10px;
    font-size: 1.6rem;
    line-height: 1.3;
    img {
        width: 100%;
        object-fit: cover;
    }
    address {
        margin: 0;
    }
    p {
        margin: 10px 0 0;
    }

@media (max-width: 600px) {
    grid-template-columns: 50px 1fr;
}

`;




export default ItemStyles;